export default "__VITE_ASSET__Bls$EBLp__"